import { Type } from 'class-transformer';
import { SerialNumber } from './SerialNumber';
import { Resource } from './Resource';
import { Model } from './Model';
import { Account } from './Account';
import { CheckInterval } from '@/modules/backend/Dto/CheckInterval';
import { Location as RouterLocation } from 'vue-router/types/router';

export class Counter {
  private readonly id!: number;

  @Type(() => SerialNumber)
  private readonly serialNumber!: SerialNumber;

  @Type(() => Resource)
  private readonly resource!: Resource;

  private readonly initialValue!: number;

  private readonly value!: number;

  private readonly channel!: number;

  @Type(() => Model)
  private readonly model!: Model;

  @Type(() => Account)
  private readonly account!: Account;

  @Type(() => CheckInterval)
  private readonly checkInterval!: CheckInterval;

  private readonly note!: string;

  private readonly stamp!: string;

  public getId(): number {
    return this.id;
  }

  public getSerialNumber(): SerialNumber {
    return this.serialNumber;
  }

  public getInitialValue(): number {
    return this.initialValue;
  }

  public getValue(): number {
    return this.value;
  }

  public getChannel(): number {
    return this.channel;
  }

  public getResource(): Resource {
    return this.resource;
  }

  public getModel(): Model {
    return this.model;
  }

  public getAccount(): Account {
    return this.account;
  }

  public getCheckInterval(): CheckInterval {
    return this.checkInterval;
  }

  public getStamp(): string {
    return this.stamp;
  }

  public getNote(): string {
    return this.note;
  }

  public getRouteLocation(): RouterLocation {
    return {
      name: 'dashboard.account.counter',
      params: {
        counterId: String(this.getId()),
      },
    };
  }
}
